import { wxConfigG } from './third'

/** 处理地理位置 */
export default class WxLocationController {
  /** 当前定位信息 */
  private static nowLocation: ILocation
  /**
   * 获取微信定位信息
   */
  static async init (): Promise<ILocation> {
    return await this.getLocation().catch((error: IPositionError) => {
      return {
        error: true,
        message: error.message,
        invalid: error.invalid,
      }
    })
  }
  static getLocation (): Promise<ILocation> {
    return new Promise((resolve, reject) => {
      wxConfigG.init(() => {
        wxConfigG.getLocation((location) => {
          resolve(location)
        }, (error) => {
          reject({
            invalid: error?.errMsg?.includes('invalid signature'),
            error: true,
            message: '获取定位信息失败'
          })
        })
      }, (error) => {
        reject({
          invalid: error?.errMsg?.includes('invalid signature'),
          error: true,
          message: '获取定位信息失败'
        })
      })
    })
  }
}
